
export default {
    name: 'recap-produits',
    components: {},
    props: {
        modal_title: String,
        produits: Array,
        has_day: Boolean,
        modal_toggler: Number
    },

    data() {
        return {
            fields: [
                { key: 'libelle', label: 'Libelle' },
                { key: 'qty', label: 'Quantité' },
                { key: 'expiry_date', label: 'Date de péremption' },
            ],
            currentPage: 1,
            perPage: 20, 
            prod_filter: ''
        }
    },

    watch: {
        modal_toggler() {
            
            if (this.has_day) {
                this.fields.push({ key: 'jour_restant', label: 'Jour(s) restant(s)' })
            } else {
                this.fields = this.fields.filter(field => field.key !== 'jour_restant')
            }
        }
    },  

    computed: {

    },

    mounted() {

    },

    methods: {

    }
}